export function isShiftMouseEvent(event: React.MouseEvent | React.FormEvent): boolean {
  return 'shiftKey' in event ? event.shiftKey : false;
}

export type DoNothingType = () => void;

export function doNothing(): void {
  return;
}

export function always(): boolean {
  return true;
}

interface BlobToBase64 {
  b64: string;
  b64Url: string;
}

export async function blobToBase64(blob: Blob): Promise<BlobToBase64> {
  const reader = new FileReader();
  reader.readAsDataURL(blob);

  return new Promise(resolve => {
    reader.onloadend = () => {
      if (!reader.result) throw new Error('Failed go get Base64 from blob.');

      const b64Url = reader.result.toString();
      // Have to remove data url declaration - 'data:*/*;base64,';
      const base64StartIndex = b64Url.lastIndexOf(',') + 1;

      resolve({ b64: b64Url.substr(base64StartIndex), b64Url });
    };
  });
}

/**
 * Replace the file extension in a filename with a new extension.
 * If the filename already has the target extension, returns it unchanged.
 *
 * @param filename - The original filename (may or may not have an extension)
 * @param newExtension - The new extension to use (with or without leading dot)
 * @returns The filename with the new extension
 *
 * @example
 * setFileExtension('document.docx', 'pdf') // 'document.pdf'
 * setFileExtension('document.docx', '.pdf') // 'document.pdf'
 * setFileExtension('document', 'pdf') // 'document.pdf'
 * setFileExtension('document.pdf', 'pdf') // 'document.pdf'
 */
export function setFileExtension(filename: string, newExtension: string): string {
  const normalizedExtension = (
    newExtension.startsWith('.') ? newExtension : `.${newExtension}`
  ).toLowerCase();

  const alreadyUseCorrectExt = filename.toLowerCase().endsWith(normalizedExtension);
  if (alreadyUseCorrectExt) return filename;

  const lastDotIndex = filename.lastIndexOf('.');

  // If there's no dot, or the dot is at the beginning (hidden file), just append the extension
  if (lastDotIndex === -1 || lastDotIndex === 0) return filename + normalizedExtension;

  return filename.substring(0, lastDotIndex) + normalizedExtension;
}
